import moment from 'moment'

/** Hotels with no PMS sync payload within this window are treated as stale (alert). */
export const PMS_SYNC_STALE_AFTER_DAYS = 2

/**
 * True when the last PMS info timestamp is older than {@link PMS_SYNC_STALE_AFTER_DAYS} days.
 * @param {string | null | undefined} pmsSyncLastInfoReceivedOn
 * @param {import('moment').Moment} [referenceMoment]
 */
export function isPmsSyncLastInfoStale(pmsSyncLastInfoReceivedOn, referenceMoment = moment()) {
  if (!pmsSyncLastInfoReceivedOn) {
    return false
  }

  const staleBefore = referenceMoment.clone().subtract(PMS_SYNC_STALE_AFTER_DAYS, 'days')
  // API timestamps are UTC without an explicit offset; parse as UTC so the result is identical for
  // every viewer (a local parse shifted status counts by the viewer's timezone near the threshold).
  return moment.utc(pmsSyncLastInfoReceivedOn).isBefore(staleBefore)
}

/**
 * PEP health display and 48h report overrides must not treat stale last-sync as recent data.
 * @param {string | null | undefined} pmsSyncLastInfoReceivedOn
 * @param {number | undefined} pmsSyncTotalReportsReceivedInLast48Hours
 */
export function getEffectivePmsReportsInLast48Hours(
  pmsSyncLastInfoReceivedOn,
  pmsSyncTotalReportsReceivedInLast48Hours
) {
  if (isPmsSyncLastInfoStale(pmsSyncLastInfoReceivedOn)) {
    return 0
  }

  return pmsSyncTotalReportsReceivedInLast48Hours ?? 0
}
